import React from 'react';
// import {Link} from 'react-router-dom';

class Header extends React.Component {
	render(){
		return(
			<div>
				<div className="navbar-top">
	            <div className="nav-wrapper">
	              <div className="side-nav-panel-left">
	                <a data-activates="slide-out-left" className="side-nav-left"><i className="fa fa-bars"></i></a>
	              </div>
	              <div className="site-brand">
	                <a href="/"> 
	                  <h3><span className="st2">XPRESS</span><span className="st1">Lite</span></h3>
	                  </a>
	              </div>
	            </div>
				{/* <div className="downloadassets">
					<a href="/assetsDownload"><i className="fa fa-download"></i></a>
				</div>  */}
	          </div>
	          
	          <div className="side-nav-panel-left">
	            <ul id="slide-out-left" className="side-nav side-nav-panel collapsible">
	              <li className="profil">
	                
	                <h2><span className="st2">XPRESS</span><i>Lite</i></h2>
	              </li>
	              <li className="li-top">
	                <a href="/"><i className="fa fa-home"></i>Home</a>
	              </li>
	              <li>
	                <div className="collapsible-header"><i className="fa fa-th-large"></i>Sections <span><i className="fa fa-caret-down"></i></span></div>
	                <div className="collapsible-body">
	                  <ul className="side-nav-panel">
	                    <li><a href="/happenings"><i className="fa fa-list-ul"></i>Happenings</a></li>
	                    <li><a href="/awardsrecognition"><i className="fa fa-list-ul"></i>Awards & Recognitions</a></li>
	                    <li><a href="/chairmanmessage"><i className="fa fa-list-ul"></i>Chairman's Messages</a></li>
	                    <li><a href="/directormessage"><i className="fa fa-list-ul"></i>Directors' Messages</a></li>
	                  </ul>
	                </div>
	              </li>
	              
				  <li><a href='/bulletin'><i className="fa fa-newspaper"></i>XpressNews Archive</a></li>
				  <li><a href='/specialbulletin'><i className="fa fa-newspaper"></i>Special Bulletins</a></li>
				  <li><a href='https://iocl.com/uploads/IONJuly2023Final.pdf' target="_blank"><i className="fa fa-newspaper"></i>IndianOil News</a></li>
				  <li><a href="/covid" ><i className="fa fa-medkit"></i>Advisory on Coronavirus Prevention</a></li>
				  <li><a href="/promotion" ><i className="fa fa-list-ul"></i>Promotions and Transfers</a></li>
				  <li><a href="/privacy" ><i className="fa fa-lock"></i>Privacy Policy</a></li>
				  <li><a href="/aboutus" ><i className="fa fa-user"></i>About Us</a></li>
	              
	            </ul>
	          </div>
	        </div>
		)
	}

}
export default Header;


// WEBPACK FOOTER //
// ./src/Header.js